/**
 * Slick carousel for multiple eligible `cart_promotion` metaobjects (see snippets/cart-promo.liquid).
 * Re-inits after cart drawer HTML is replaced via AJAX (custom.js openCart).
 */
(function () {
    function whenSlickReady(cb) {
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
            return cb();
        }
        var tries = 0;
        (function wait() {
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
                return cb();
            }
            if (tries++ > 60) {
                return;
            }
            setTimeout(wait, 100);
        })();
    }

    function initCartPromoCarousels(root) {
        whenSlickReady(function () {
            var $ = window.jQuery;
            var $scope = root ? $(root) : $(document);
            $scope.find(".js-cart-promo-slick").each(function () {
                var $el = $(this);
                if ($el.hasClass("slick-initialized")) {
                    $el.slick("unslick");
                }
                var $slides = $el.children(".cart-promo-carousel__slide");
                if ($slides.length < 2) {
                    return;
                }
                $el.slick({
                    dots: true,
                    arrows: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                });
            });
        });
    }

    window.initCartPromoCarousels = initCartPromoCarousels;

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            initCartPromoCarousels(document);
        });
    } else {
        initCartPromoCarousels(document);
    }

    if (window.jQuery) {
        window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
            var url = settings && settings.url ? String(settings.url) : "";
            if (url.indexOf("cart?view=drawer") === -1 && url.indexOf("/cart?view=drawer") === -1) {
                return;
            }
            setTimeout(function () {
                var drawer = document.querySelector(".drawer__cart");
                initCartPromoCarousels(drawer || document);
            }, 0);
        });
    }

    document.addEventListener("shopify:section:load", function (event) {
        if (event && event.target) {
            initCartPromoCarousels(event.target);
        }
    });
})();
